export const NEW_NAVIGATION = 'onboarding_new_navigation'
